import { useEffect, useState } from "react";
import { Star, Users } from "lucide-react";
import adminService from "../../../../services/adminService";
import "./AdminEvaluations.scss";

export default function AdminEvaluations() {
  const [evaluations, setEvaluations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadEvaluations();
  }, []);

  const loadEvaluations = async () => {
    try {
      const data = await adminService.getEvaluations();
      setEvaluations(data);
    } catch (error) {
      console.error("Erro ao carregar avaliações:", error);
    } finally {
      setLoading(false);
    }
  };

  // Calcula estatísticas
  const averageRating = evaluations.length > 0
    ? (evaluations.reduce((sum, e) => sum + e.rating, 0) / evaluations.length).toFixed(1)
    : 0;

  if (loading) {
    return <div className="admin-loading">Carregando avaliações...</div>;
  }

  if (evaluations.length === 0) {
    return (
      <div className="admin-empty-state">
        Nenhuma avaliação encontrada.
      </div>
    );
  }

  return (
    <div className="admin-evaluations">
      <div className="admin-evaluations__header">
        <h2>
          <Star size={18} />
          Avaliações
        </h2>
        <div className="admin-evaluations__stats">
          <span className="admin-evaluations__stat">
            <Users size={14} />
            {evaluations.length}
          </span>
          <span className="admin-evaluations__stat">
            <Star size={14} />
            {averageRating}
          </span>
        </div>
      </div>

      <div className="admin-evaluations__table">
        <div className="admin-evaluations__head">
          <span>Nota</span>
          <span>Avaliador</span>
          <span>Avaliado</span>
          <span>Vaga</span>
          <span>Comentário</span>
          <span>Data</span>
        </div>

        {evaluations.map((evaluation) => (
          <div
            key={evaluation.id}
            className="admin-evaluations__row"
          >
            <span>
              <Star size={16} />
              {evaluation.rating}
            </span>

            <span title={evaluation.evaluatorName}>
              {evaluation.evaluatorName}
            </span>

            <span title={evaluation.targetName}>
              {evaluation.targetName}
            </span>

            <span title={evaluation.jobTitle}>
              {evaluation.jobTitle}
            </span>

            <span title={evaluation.comment || "Não Comentou"}>
              {evaluation.comment || ""}
            </span>

            <span>
              {new Date(evaluation.createdAt).toLocaleDateString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
              })}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}